import React from 'react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import './PromotersTable.scss';

import {
  Grid,
  GridCell,
  GridLabels,
  GridRow,
} from '../../../../../common/components/Grid/Grid';
import { ThreeDotMenu } from '../../../../../common/components/ThreeDotMenu/ThreeDotMenu';

type Value = {
  copyable: string;
  title: string;
};
type model = {
  active: boolean;
  id?: number;
  name?: string;
  typeTitle?: string;
  updatedAt?: string;
  value: Value;
  pageId: number;
};

type Props = {
  promoters: model[];
  edit: (promoterId: number, dialogueId: number, typeTitle: string) => void;
  delete: (id: number) => void;
};

const actions = [
  { name: 'Edit', value: 'edit' },
  { name: 'Delete', value: 'delete' },
];

const PromotersTableRow = ({
  promoter,
  onDelete,
  edit,
}: {
  onDelete: (id?: number) => void;
  edit: (id?: number, dialogueId?: number, typeTitle?: string) => void;
  promoter: model;
}) => {
  const onSelectItem = (value: string) => {
    if (value === 'edit') {
      edit(promoter.id, promoter.pageId, promoter.typeTitle);
    }
    if (value === 'delete') {
      onDelete(promoter.id);
    }
  };

  if (promoter) {
    const formattedUpdatedAt = moment(promoter.updatedAt).format('MM/DD/YYYY');

    return (
      <GridRow
        key={promoter.id}
        className="start-bot-promoter-table__table-row"
      >
        <GridCell
          onClick={() => edit(promoter.id, promoter.pageId, promoter.typeTitle)}
          fr={2.5}
          className="start-bot-promoter-table__table-name"
        >
          <strong>{promoter.name}</strong>
        </GridCell>

        <GridCell>{promoter.active ? 'Active' : 'Draft'}</GridCell>

        <GridCell>
          <CopyToClipboard text={promoter.value.copyable}>
            <span className="start-bot-promoter-table__copy-link">
              {promoter.value.title}
            </span>
          </CopyToClipboard>
        </GridCell>
        <GridCell>{promoter.typeTitle}</GridCell>
        <GridCell>{formattedUpdatedAt}</GridCell>

        <GridCell
          overflowable
          className="start-bot-promoter-table--action-cell"
        >
          <ThreeDotMenu elements={actions} selectItem={onSelectItem} />
        </GridCell>
      </GridRow>
    );
  }

  return null;
};

export const PromotersTable = (props: Props) => {
  const { promoters, edit, delete: onDelete } = props;

  return (
    <Grid className="start-bot-promoter-table__table">
      <GridLabels>
        <GridCell fr={2.5}>Name</GridCell>
        <GridCell>Status</GridCell>

        <GridCell>Link/Code</GridCell>

        <GridCell>HTML Element Type</GridCell>
        <GridCell>Updated</GridCell>
        <GridCell className="start-bot-promoter-table--action-cell">
          Actions
        </GridCell>
      </GridLabels>

      {promoters.map(promoter => (
        <PromotersTableRow
          edit={edit}
          onDelete={onDelete}
          key={promoter.id}
          promoter={promoter}
        />
      ))}
    </Grid>
  );
};
